import { AxiosError } from "axios";
import { retryQueryConfig } from "src/Pages/Company/OrganizationStructure/config/retryQueryConfig";
import { useQuery } from "@tanstack/react-query";
import { fetchStructureData } from "src/Pages/Company/OrganizationStructure/api";
import { IStructureData } from "src/Pages/Company/OrganizationStructure/ConfigureStructure/CreateStructure/StructureData.schema";

const useFetchStructureData = (
  companyId: string,
  structureId: string | undefined
) =>
  useQuery<IStructureData, AxiosError>({
    enabled: !!companyId && !!structureId,
    queryKey: ["structure-data", { companyId, structureId }],
    queryFn: async ({ signal }) => {
      const data = await fetchStructureData(companyId, structureId!, {
        signal,
      });
      return data;
    },
    ...retryQueryConfig,
  });

export default useFetchStructureData;
